import { FC } from 'react';
import { Card, CardHeader, CardSection, Grid } from 'lib/components';
import { DefaultLayout, CancelledPlanRatingForm, RedirectRouter } from '../../../components';
import { CancellationStepPageProps, CancellationStepProps } from './suggestions';

const ConfirmCancel: FC<CancellationStepProps> = ({ cancellation }) => (
  <DefaultLayout>
    <Grid>
      <Card className="col-span-12">
        <CardSection>
          <CardHeader>
            <h3>Your Subscription Has Been Canceled</h3>
            <p>
              We are always trying to make NIBLL a better experience, your feedback will help us to improve our service
              for others.
            </p>
          </CardHeader>
        </CardSection>
      </Card>

      <Card className="col-span-12">
        <CardSection>
          <CardHeader>
            <h3>How was your experience?</h3>
            <CancelledPlanRatingForm cancellation={cancellation} />
          </CardHeader>
        </CardSection>
      </Card>
    </Grid>
  </DefaultLayout>
);

const ConfirmCancelPage: FC<CancellationStepPageProps> = ({ location }) => (
  <RedirectRouter
    component={<ConfirmCancel cancellation={location?.state?.cancellation} />}
    location={location}
    to={'/account/cancel'}
  />
);

export default ConfirmCancelPage;
